import type { Me } from "./types";

// `tool` is the bare command `dense persist <tool>` shims; null = not shimmable.
export type Harness = {
  id: string;
  name: string;
  tool: string | null;
  wrap: string;
  logo: string | null;
};
export const HARNESSES: Harness[] = [
  {
    id: "claude",
    name: "Claude Code",
    tool: "claude",
    wrap: "dense claude",
    logo: "/logos/claude-mark.png",
  },
  {
    id: "codex",
    name: "Codex",
    tool: "codex",
    wrap: "dense codex",
    logo: "/logos/openai-codex.png",
  },
  {
    id: "opencode",
    name: "opencode",
    tool: "opencode",
    wrap: "dense opencode",
    logo: "/logos/opencode-mark.png",
  },
];
export const OTHER_HARNESS: Harness = {
  id: "other",
  name: "your agent",
  tool: null,
  wrap: "dense <your-agent>",
  logo: null,
};

// Unknown / unset never silently becomes Claude — the user has to pick.
export function resolveHarness(id: string): Harness {
  return HARNESSES.find((h) => h.id === id) ?? OTHER_HARNESS;
}

// The installer hands off to `dense setup`, whose device-flow login mints a
// `sub` key named `dense <code>` — the only server-side proof of an install.
export function denseKeyIds(me: Me): string[] {
  return (me.keys ?? [])
    .filter((k) => k.kind === "sub" && (k.name ?? "").startsWith("dense "))
    .map((k) => k.id);
}

// `seen` = keys already present when the wizard mounted; an old install on
// the account must not tick the step off before anything was run.
export function denseLinked(me: Me, seen: Set<string> = new Set()): boolean {
  return denseKeyIds(me).some((id) => !seen.has(id));
}

// Wizard resume state; Cli.tsx reads it too, to name the picked agent.
export const WIZARD_KEY = "condense.onboarding.v1";
export function clearWizard(): void {
  try {
    localStorage.removeItem(WIZARD_KEY);
  } catch {
    /* ignore */
  }
}
